/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NftMetadataAttribute
 */
export interface NftMetadataAttribute {
    /**
     * 
     * @type {string}
     * @memberof NftMetadataAttribute
     */
    trait_type: string;
    /**
     * 
     * @type {string}
     * @memberof NftMetadataAttribute
     */
    value: string;
}

/**
 * Check if a given object implements the NftMetadataAttribute interface.
 */
export function instanceOfNftMetadataAttribute(value: object): value is NftMetadataAttribute {
    if (!('trait_type' in value) || value['trait_type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NftMetadataAttributeFromJSON(json: any): NftMetadataAttribute {
    return NftMetadataAttributeFromJSONTyped(json, false);
}

export function NftMetadataAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftMetadataAttribute {
    if (json == null) {
        return json;
    }
    return {
        
        'trait_type': json['trait_type'],
        'value': json['value'],
    };
}

export function NftMetadataAttributeToJSON(json: any): NftMetadataAttribute {
    return NftMetadataAttributeToJSONTyped(json, false);
}

export function NftMetadataAttributeToJSONTyped(value?: NftMetadataAttribute | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trait_type': value['trait_type'],
        'value': value['value'],
    };
}

